import styled, { css } from 'styled-components';

import { mediaQuery } from '../../styles/mixin';

interface IContainerProps {
    shown?: boolean;
}

export const Container = styled.section<IContainerProps>`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    border: 1px solid ${({ theme }) => theme.colors.mediumShadow};
    box-shadow: 0px 0px 10px 4px rgba(0, 0, 0, 0.04);
    padding: 1rem;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    transform: ${({ shown }) => (shown ? 'translateY(0)' : 'translateY(100%)')};
    background: ${({ theme }) => theme.colors.bgTernary};
    transition: all ${({ theme }) => theme.transitions.hover};
    ${mediaQuery(
        2,
        css`
            /* basic left margin, menu width, page padding */
            left: calc(1.5rem + 21rem + 1.25rem);
            right: 1.5rem;
            border-radius: 8px 8px 0px 0px;
        `
    )}
`;

export const Text = styled.h3`
    font-weight: 600;
    font-size: ${({ theme }) => theme.fontSizes[5]};
    line-height: 1.5;
    ${mediaQuery(
        2,
        css`
            margin-left: 0.5rem;
        `
    )}
`;

export const ActionContainerClassName = styled.div`
    display: flex;

    button {
        margin-left: 10px;
        margin-right: 10px;
    }
`;
